import { NFetch, SERVER } from '../api';

export const profileActions = {
    changePassword,
    resetPassword,
    resetPasswordByAdmin
};

function changePassword(oldpassword, newpassword) {
    let _param = {
        oldPassword: oldpassword,
        newPassword: newpassword
    }
    return NFetch.Post(SERVER.API.ChangePassword, _param)
}
function resetPassword(id, newPassword) {
    return NFetch.Patch(SERVER.API.ResetPassword + '/' + id, { password: newPassword })
}
function resetPasswordByAdmin(id, newPassword) {
    return NFetch.Post(SERVER.API.resetPasswordByAdmin, { id: id, newPassword: newPassword })
}